import * as React from 'react'
import Radio from '@material-ui/core/Radio'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Typography from '@material-ui/core/Typography'
import * as moment from 'moment'

import IContest from 'src/models/IContest'

interface IEntrySelectionProps {
  selectedLevel?: string
  contest: IContest
  onChange: React.ChangeEventHandler
}

class EntrySelection extends React.PureComponent<IEntrySelectionProps> {
  public renderHelpText = () => {
    const { contest } = this.props
    const { lateFeeStartDate, entryDeadline, entryLevels } = contest

    let message = ''

    if (lateFeeStartDate) {
      const lateFees = entryLevels
        .map(level => `$${level.lateFee} ${level.value}`)
        .join(', ')

      message = `Late entry fees apply after ${moment(lateFeeStartDate).format(
        'M/D'
      )} (${lateFees}). `
    }

    if (entryDeadline) {
      message += `No entries accepted after ${moment(entryDeadline).format(
        'M/D'
      )}.`
    }

    if (message.length > 0) message = '* ' + message

    return message
  }

  public render() {
    const { onChange, selectedLevel, contest } = this.props

    return (
      <>
        <Typography variant="h6" gutterBottom>
          Registration
        </Typography>

        <FormGroup row>
          <FormControlLabel
            name="level"
            key="none"
            control={<Radio color="primary" checked={!selectedLevel} />}
            onChange={onChange}
            label="No Registration"
          />
          {contest.entryLevels.map(level => (
            <FormControlLabel
              name="level"
              key={level.value}
              value={level.value}
              control={
                <Radio
                  color="primary"
                  checked={level.value === selectedLevel}
                />
              }
              onChange={onChange}
              label={`${level.name} ($${level.price})`}
            />
          ))}

          {selectedLevel && (
            <FormHelperText>{this.renderHelpText()}</FormHelperText>
          )}
        </FormGroup>
      </>
    )
  }
}

export default EntrySelection



// WEBPACK FOOTER //
// ./src/components/contest/EntrySelection.tsx